const USER = '/user'
const USER_RESTORE = '/user/restore'
const PROFILE = `${USER}/profile`
const LIST = `${USER}/list`
const USER_ONBOARDING = `${USER}/onboarding`
const USER_DELETE = `/user/delete`;

export { USER, USER_RESTORE, PROFILE, LIST, USER_ONBOARDING, USER_DELETE }
